import React, { useState } from "react";
import logo from "../../assets/logo.png";
import styles from "./Login.module.css";
import Auth from "../../utils/api/Auth";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { userDataActions } from "../../store/redux-store/Index";

function RequestReset() {
  const [input, setInput] = useState({
    email: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInput({ ...input, [name]: value });
  };
  const submitLoginHandler = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const resetPasswordRes = await Auth.requestPasswordReset({
        email: input.email,
      });
      
      toast.success(resetPasswordRes.data.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        style: {
          backgroundColor: "#FFFFFF",
          color: "#000000",
        },
      });
      dispatch(userDataActions.getResetEmail(input.email));

      setIsLoading(false);

      navigate("/password-reset");
    } catch (err) {
      setIsLoading(false);
      toast.error(err?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        style: {
          backgroundColor: "#FFFFFF",
          color: "#000000",
        },
      });
    }
  };

  return (
    <div className={styles.main}>
      <ToastContainer />
      <div className={styles.main_header}></div>

      <div className={styles.main_content}>
        <div className={styles.main_content_logo}>
          <img src={logo} alt="logo" />
        </div>
        <div className={styles.main_content_inner}>
          <p>Reset Password</p>
        </div>
        <form
          onSubmit={submitLoginHandler}
          className={styles.main_content_inner_form}
        >
          <input
            type="email"
            placeholder="Enter Email"
            name="email"
            required
            value={input.email}
            onChange={handleInputChange}
            className={styles.input_field}
          />

          <button
            type="submit"
            className={styles.login_button}
            disabled={isLoading}
            style={{
              cursor: isLoading ? "not-allowed" : "default",
              opacity: isLoading ? 0.5 : 1,
            }}
          >
            {isLoading ? `Loading...` : `Request code`}
          </button>
        </form>
      </div>
    </div>
  );
}

export default RequestReset;
